export default [
    {
        path: '/futures/options',
        component: () => import('@/pages/games/options'),
    },
  ];
  


// WEBPACK FOOTER //
// ./src/router/v2/options.js